import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=5a3d2984"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"
import style0 from "./ProductCategories.vue?vue&type=style&index=0&id=5a3d2984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports